<sc-flex fitHeight vertical stretchContent
    *ngIf="station?.stationUsage?.transports.length>0">
    <sc-flex-fitting-content vertical>
        <sc-padding fitHeight>
            <sc-scroll-pane>
                <app-transport-documents-list
                    [transportId]="station?.stationUsage?.transports[0].id"
                    [forceReloadRequest]="forceRefreshSubject"></app-transport-documents-list>
            </sc-scroll-pane>
        </sc-padding>
    </sc-flex-fitting-content>
    <sc-padding>
        <sc-flex [centered]="true">
            <app-transport-photo-button
                (onDocumentUploaded)="refreshDocuments()"
                [transportId]="station?.stationUsage?.transports[0].id"></app-transport-photo-button>
        </sc-flex>
    </sc-padding>
</sc-flex>
